import { useTranslation } from 'react-i18next';
import { useDrawer } from 'src/hooks/useDrawer';
import { useSettings } from 'src/modules/settings';

export const LiveChatButton = () => {
  const { t } = useTranslation();
  const { closeDrawer } = useDrawer();
  const {
    chat: { openLiveChat }
  } = useSettings();

  const handleChatButtonClick = () => {
    closeDrawer();
    openLiveChat();
  };

  return (
    <div
      className="flex justify-start items-center gap-2 w-full group cursor-pointer"
      onClick={handleChatButtonClick}>
      <p className="text-sgc_page_item_color text-base font-medium px-2 group-hover:text-sgc_page_item_color_hovered transition-colors duration-200">
        {t('mainSidebarLinks.liveChat')}
      </p>
    </div>
  );
};
